import React, { useEffect, useState } from 'react';
import { dataService } from "../../../services/dataService";
import Util from "../../../utils/utils";

const ScrollToTop = () =>
{
	const [ isVisible, setIsVisible ] = useState( false );
	const token = Util.getSession( "token" );
	const [ state, setState ] = useState( {
		"name" : '',
		"url" : ''
	} );

	const scrollToTop = () =>
	{
		window.scrollTo( {
			top : 0,
			behavior : "smooth"
		} );
	};

	useEffect( () =>
	{
		try
		{
			dataService.getData().subscribe( message =>
			{
				let data = message.value;

				if ( data.action === "edit" )
				{
					setState( ( oldState ) => ( { ...oldState, data } ) );
				}
				else
				{
					setState( data );
				}

			} );
		}
		catch ( e )
		{
			console.log( "Error: " + e )
		}

	}, [] );

	useEffect( () =>
	{
		const toggleVisibility = () =>
		{
			const scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;

			if ( scrollPosition > 250 )
			{
				setIsVisible( true );
			}
			else
			{
				setIsVisible( false );
			}
		};

		window.addEventListener( "scroll", toggleVisibility, true );

		return () => window.removeEventListener( "scroll", toggleVisibility );
	}, [] );

	let bottomPx = 100;

	if ( state.name === "" || state.url === "" )
		bottomPx = 20;

	if ( !token )
		return ( <> </> );

	return (
		<>
			{
				isVisible &&
				(
					<div id="return-to-top" className="scroll-to-top" style={{ bottom : bottomPx }} onClick={scrollToTop}>
						<i className="fa fa-arrow-up"/>
					</div>
				)
			}
		</>
	);
};

export default ScrollToTop;